<template>
  <template v-if="isMobile">
    <slot name="anchor" />

    <UiDialogBasic
      v-bind="{ ...drawer, attrs }"
      v-model:open="popoverDrawerModel"
      :trap-focus="false"
      :classes="classes?.drawer"
      @update:open="emit('close')"
    >
      <template #trigger><slot name="trigger" /></template>

      <UiDialogTitle class="sr-only"></UiDialogTitle>

      <div class="flex flex-col">
        <slot v-if="$slots.drawer" v-bind="{ close }" name="drawer" />
        <slot v-else v-bind="{ close }" />
      </div>
    </UiDialogBasic>
  </template>

  <UiPopover
    v-else
    v-bind="popover"
    v-model:model-value="popoverDrawerModel"
    @close="emit('close')"
    :classes="{
      ...classes?.popover,
      trigger: classes?.popover?.trigger,
      body: cn('p-s shadow-[0_0_12px_2px_rgba(234,235,235,0.8)]', classes?.popover?.body),
    }"
  >
    <template #anchor><slot name="anchor" /></template>

    <template #trigger><slot v-bind="{ isOpen: popoverDrawerModel }" name="trigger" /></template>

    <slot v-if="!isMobile" v-bind="{ close }" />
  </UiPopover>
</template>

<script setup lang="ts">
import { UiDialogBasicClasses, UiDialogBasicProps } from "./Dialog/Basic.vue"
import { UiPopoverProps } from "./Popover/index.vue"

const emit = defineEmits(["update:modelValue", "close"])

export type PopoverDrawerClasses = {
  popover: Partial<{ root: ClassValue; trigger: ClassValue; body: ClassValue }>
  drawer: Partial<UiDialogBasicClasses>
}

const attrs = useAttrs()
const popoverDrawerModel = defineModel({ default: false })
const { isMobile } = useDisplay()
const props = defineProps<{
  id?: string
  classes?: Partial<PopoverDrawerClasses>
  popover?: Partial<UiPopoverProps>
  drawer?: Partial<UiDialogBasicProps>
}>()

const close = (callback?: () => void) => {
  popoverDrawerModel.value = false

  callback?.()
}
</script>
